"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.image = exports.linkWrapper = exports.titleWrapper = exports.wrapper = exports.root = void 0;

const root = () => ({
  height: 144,
  overflow: 'hidden',
  position: 'relative',
  width: 277
});

exports.root = root;

const wrapper = () => ({
  maxWidth: 240
});

exports.wrapper = wrapper;

const titleWrapper = () => ({
  maxWidth: 160
});

exports.titleWrapper = titleWrapper;

const linkWrapper = () => ({
  cursor: 'pointer',
  transition: 'all 0.2s ease !important',
  ':hover': {
    transform: 'scale(1.1)'
  }
});

exports.linkWrapper = linkWrapper;

const image = () => ({
  height: 72
});

exports.image = image;
//# sourceMappingURL=AssetCard.style.js.map